import { Box, Paper, Grid, Divider } from "@mui/material";
import "./Header.css";
import React from "react";
import PageTab from "../PageTab/PageTab";
import { Context } from "../../Context";
import PageURL from "../../PageURL";

function Header() {
  // const [tab, setTab] = React.useState(0);
  const {pageIndex,setPageChange} = React.useContext(Context);
  const tabs = React.useMemo(() => {
    return PageURL.map(({ name, url }, index) => (
      <React.Fragment key={"header "+name}>
        {index !== 0 && (
          <Grid item>
            <Divider orientation="vertical" />
          </Grid>
        )}
        <Grid item onClick={()=>setPageChange(index)}>
          <PageTab url={url} name={name} isActive={pageIndex===index}/>
        </Grid>
      </React.Fragment>
    ));
  }, [pageIndex]);
  return (
    <div id="Header">
      <div className="headerSpace"></div>
      <Paper elevation={2} className="grouptab">
        <Grid container direction={"row"} spacing={1}>
          {tabs}
        </Grid>
      </Paper>
    </div>
  );
}

export default Header;
